<template>
  <v-card class="assessment-light">
    <v-card-text class="subtitle-1 assessment-light">
      <mrx-translation :token="prompt"></mrx-translation>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    name: 'rdtstatus',
    data() {
      return {}
    },
    model: {
      prop: 'items',
      event: 'click'
    },
    props: {
      'options': { type: Object, default: {} },
      'items': Array,
      'panelName': String
    },
    computed: {
      prompt() {
        let selected = this.items.find(x => x.selected)
        return `responses.rdt_status.${selected.value}.details`
      }
    },
    methods: {},
    mounted() {

    }
  }
</script>
